import { createPutRequestOpts, fetchJsonQuery } from "@mne-core/api";
import type { IRequestOpts, IResultstash } from "@mne-core/api";
import { QueryController, createUrl } from "@mne-core/api";

export interface ICreateActivateEnrollmentByCriteria {
  userName: string;
  enrollmentCode: string;
  domain: string;
}

export interface ICreateActivateEnrollmentByCriteriaResponse {
  userID: number;
  activationCookie: string;
}

export const createRequest = (
  { ...restCriteria }: ICreateActivateEnrollmentByCriteria,
  opts: IRequestOpts,
): Request => {
  const { apiUrl, sessionKey, ...restOpts } = opts;
  const uri = createUrl(apiUrl, ["authentication", "v1", "enroll"]).toString();
  return new Request(uri, createPutRequestOpts(JSON.stringify(restCriteria), { ...restOpts }));
};

export const createActivateEnrollmentByCriteria = async (
  criteria: ICreateActivateEnrollmentByCriteria,
  opts: IRequestOpts,
) =>
  fetchJsonQuery<IResultstash<ICreateActivateEnrollmentByCriteriaResponse>>(createRequest(criteria, opts), {
    ctrl: opts.ctrl || new QueryController(),
  });
